import { PromoBanner } from '../PromoBanner';

type TMidnightAffixesUpsellProps = {
  className?: string;
};

export function MidnightAffixesUpsell(props: TMidnightAffixesUpsellProps) {
  return (
    <PromoBanner
      className={props.className}
      url="https://raider.io/news/740-midnight-mythic-plus-affixes"
      blurb={'\u{1F3B2} New affixes are shaking up Mythic+ in Midnight Season 1! Learn how the revamped affix system works, what to expect at every key level, and how to prepare your group. \u2694\uFE0F'}
      buttonText="Read the Guide"
      trackingSlug="midnight_affixes_upsell"
      imagePath="/images/upsells/midnight-affixes/banner.webp"
      imageAlt="Midnight Season 1 Mythic+ Affixes"
      borderColor="#4db8d1"
      background="linear-gradient(76deg, #1a1a2e 0%, #162a3e 50%, #1a1a2e 100%)"
      buttonColor="#4db8d1"
    />
  );
}
